module.exports = __webpack_public_path__ + "static/media/figueredo_toward.43cd71eb.jpg";